import {
    DG_axios as axiosInstance,
    getLanguage,
    getLocalAccessToken,
    getLocalOauth2Token,
    updateLocalAccessToken
} from "../index";
import {message} from "antd";
import {refreshToken} from "../../../api/login/api";
import {Translation} from "react-i18next";
import {onChangeLoading, onChangeSuccessAxios} from "../../../redux/actions/axios/Action";
import {onReloadData} from "../../../redux/actions/layout/interaction/action";
import {logoutStart} from "../../../redux/actions/login/actions";
import {t} from "i18next";

const setup = (store) => {

    axiosInstance.interceptors.request.use(
        (config) => {

            if (config.method === 'get') {
                store.dispatch(onChangeLoading(true))
            } else {
                store.dispatch(onChangeSuccessAxios(false))
            }
            // const oauth2Token = getLocalOauth2Token();
            // const accessToken = getLocalAccessToken();
            const language = getLanguage();

            // config.headers["Authorization"] = oauth2Token;
            // config.headers["dogoo-x-user-context-request"] = accessToken;
            config.headers['Accept-Language'] = language;
            config.headers['Dogoo-Context-Env-Tnp'] = true;
            return config;

        },
        (error) => {
            store.dispatch(onChangeLoading(false))
            store.dispatch(onChangeSuccessAxios(false))

            return Promise.reject(error);
        }
    );

    function showMessageSuccess(config) {
        if (config.method === 'put' || config.method === "patch") {
            message.success(<Translation>
                {(t, {i18n}) =>
                    <span>{t("common.message.update")}</span>}
            </Translation>)
        }
        if (config.method === 'post') {
            console.log(config.url);
            if (!config.url.includes('/oauth2/token') && !config.url.includes('/token') && !config.url.includes('/logout') && !config.url.includes('/refreshtoken'))
                message.success(<Translation>
                    {(t, {i18n}) =>
                        <span>{t("common.message.add")}</span>}
                </Translation>)
        }
        if (config.method === 'delete') {
            message.success(<Translation>
                {(t, {i18n}) =>
                    <span>{t("common.message.delete")}</span>}
            </Translation>)
        }
    }

    function retryPendingRequests(token) {
        subscribers.forEach(callback => callback(token));
        subscribers = [];
    }
    let isRefreshing = false;
    let subscribers = [];
    let refreshTokenPromise = null;

    axiosInstance.interceptors.response.use(
        (res) => {
            store.dispatch(onChangeLoading(false))

            const config = res.config

            showMessageSuccess(config);
            if (config.method !== 'get') {
                store.dispatch(onReloadData(config.baseURL + config.url))
                if (config.method !== 'delete')
                    store.dispatch(onChangeSuccessAxios(true))
            }
            return res;
        },
        async (err) => {

            store.dispatch(onChangeLoading(false))
            store.dispatch(onChangeSuccessAxios(false))


            const originalConfig = err.config;

            const response = err.response;


            const data = response?.data;
            const status = response?.status

            if (status === 404) {
                message.error(t("notification.404"))
            } else if (data?.status === "INTERNAL_SERVER_ERROR") {
                message.error(t("notification.500"))
            } else {

                const detail = data?.detail || data?.message || data?.title || data?.status || t("notification.500")

                if (detail !== "username.context.is.required" &&
                    detail && status !== 403 && status !== 404) {
                    switch (status) {
                        case 500:
                            message.error(detail)
                            break
                        default:
                            message.warning(detail)
                    }
                }
            }

            if (!originalConfig.url.includes("/login-rest/v2.0/token")) {
                if (status === 401 && !originalConfig._retry) {
                    originalConfig._retry = true;
                    try {

                        if (!isRefreshing) {
                            isRefreshing = true;
                            refreshTokenPromise = refreshToken(); // Gọi refreshToken và lưu Promise vào refreshTokenPromise
                            const { accessToken } = (await refreshTokenPromise).data;
                            updateLocalAccessToken(accessToken);
                            isRefreshing = false;
                            retryPendingRequests(accessToken);
                            return axiosInstance(originalConfig);
                        } else {
                         //   await refreshTokenPromise;

                            const res = await new Promise((resolve) => {
                                subscribers.push((token) => {
                                    // originalConfig.headers["dogoo-x-user-context-request"] = token; // Cập nhật token mới
                                    originalConfig.headers["Dogoo-Context-Env-Tnp"] = true; // Cập nhật token mới
                                    resolve(axiosInstance(originalConfig));
                                });
                            });
                            return res;

                        }


                    } catch (_error) {
                        store.dispatch(logoutStart());
                        return Promise.reject(_error);
                    }
                }
            }
            if (status === 403 && !originalConfig._retry) {
                store.dispatch(logoutStart());
            }

            return Promise.reject(err);
        }
    );
};
export default setup;
